<div class="workspace-master-detail"
     [class.workspace-master-detail--open]="detailOpen">
  <!-- Keep CDK drag measurements aware of the board's scrolling container. -->
  <section #master class="workspace-master-detail__master" cdkScrollable tabindex="-1"
           [attr.aria-hidden]="detailOpen"
           [attr.inert]="detailOpen ? '' : null">
    <ng-content select="[workspace-master]"></ng-content>
  </section>

  <section #detail class="workspace-master-detail__detail" tabindex="-1"
           [attr.aria-hidden]="!detailOpen"
           [attr.inert]="!detailOpen ? '' : null">
    <ng-content select="[workspace-detail]"></ng-content>
  </section>
</div>
